import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { selectors } from 'ducks/ui';
import { historyPush } from 'utils/history';

const Template = ({ header = 'default', brandConfig }) => {
  const className = classNames('Header header', header);
  return (
    <header className={className}>
      <div className="wrapper">
        <div
          className="logo"
          onClick={() => historyPush('/')}
          role="presentation"
          style={{
            backgroundImage: brandConfig.logo && `url(${brandConfig.logo})`,
          }}
        />
      </div>
    </header>
  );
};

Template.propTypes = {
  header: PropTypes.string,
  brandConfig: PropTypes.object,
};

const mapStateToProps = (state) => ({
  header: selectors.header(state),
  brandConfig: selectors.brandConfig(state),
});

const mapDispatchToProps = () => ({});

const Header = connect(mapStateToProps, mapDispatchToProps)(Template);

export default Header;
